import { useTenantNavigate } from '@app-store'
import FormRenderer from '../components/FormRenderer'
import {
  addToaster,
  API_END_POINT,
  CaseDataType,
  DataTypeStore,
  ENTITY_MANAGER_END_POINTS,
  fetchDuplicateRecordsAPI,
  getEntityById,
  getEntityDataByEntityFilter,
  getLayoutByEntityIdAndTypeApi,
  hideLoader,
  LayoutResponseType,
  showLoader,
  transformToDuplicateApiPayload,
  updateEntityName,
  updatePatientData,
} from '@app-store'
import {
  CUSTOM_LAYOUTS_KEYS_LIST,
  LAYOUT_TYPE_NAMESPACE,
  MODE_CONSTANTS,
  NAMESPACES,
  PERMISSION_ACCESSIBILITY,
  PERMISSION_ASSIGNMENT,
  PERMISSION_MODULES,
  RECORD_STATE,
} from '../utils/constants'
import {
  EntityLayout,
  EntityLayoutResponse,
  LayoutData,
  ModeType,
} from '../types/layout.types'
import {
  CustomButton,
  Loader,
  Modal,
  SvgAudit,
  SvgEditBlue,
  SvgVerticalSplitter,
  SvgEntity,
  Tooltip,
  ConfirmDialog,
  SvgCross,
  ACTION_ICONS_NAMESPACE,
  TableActionType,
} from '@ui-kit'
import { RootState, useAppDispatch, useAppSelector } from '../utils/agent.store'
import useCustomFetchAgent from '../hooks/useCustomFetchAgent'
import {
  addEntityData,
  editEntityData,
  getEntityData,
} from '../apis/entityData.api'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { useEffect, useMemo, useRef, useState } from 'react'
import { FieldErrors, FieldValues, useFormContext } from 'react-hook-form'
import { callRoute, editRoute, entitiesRoute } from '../routes/route.constant'
// import { convertValuesToDiff } from '../utils/form.utils'
import { TOASTER_NAMESPACE } from '../constants/addEditPage.strings'
import { AddEditRecordPageProps } from '../types/pages.types'
import { AgentDeskForCaseParams, AgentDeskParams } from '../types/params.types'
import {
  APPLICATION_PREFERENCES_STRINGS,
  DUPLICATION,
  STRINGS,
} from '../utils/strings'
import { isArray, noop } from 'lodash'
import {
  hasPermission,
  isReadOnlyUser,
  isSuperAdmin,
} from '../utils/permission'
import {
  FORM_CONSTANTS,
  RECORD_STATUS,
  ShortcutKeys,
  TAB_INDEX_DEFAULT,
} from '../constants/form.constants'
import {
  capitalizeEntitySingularLabel,
  fetchCaseData,
  hasSensitiveDataPermission,
  permissionObject,
  toSpacesCase,
} from '../utils/helperFunctions'
import {
  flattenObject,
  getTypeOfLayoutByMode,
  renderValuesWithDelimiter,
  validatePhoneNumberAndAddress,
} from '../utils/form.utils'
import TabLayout from '../components/tabs/TabLayout'
import {
  getLayoutBasedOnServiceType,
  removeCheckAttachKeyFromSession,
} from '../utils/dynamic-queue'
import CheckEligibilityMaxRTE from '../components/max-rte/CheckEligibilityMaxRTE'
import { CHECK_ELIGIBILITY_LOCATION, isEntityEditRoute } from '../utils/maxRTE'
import { ListingTableRow } from '../types/listingTable.types'
import { ListingTable } from '../components/listing-table/ListingTable'
import { DuplicationScore } from '../components/DuplicationScore'
import { Group } from '../types/types'
import { ListingTableColumn } from '../utils/types'
import PatientEConsent from '../components/e-consent/PatientEConsent'
import { AddEditRecordWrapperWithHybridSupport } from './ServiceTypeAddEditViewRecordWrapper'

export const AddEditRecordWarpper: React.FC<{
  mode: ModeType
}> = ({ mode }) => {
  const navigate = useTenantNavigate()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const { comingFromAdd } = location.state ?? {}
  const { entityId, id } = useParams<AgentDeskParams>()
  return (
    <AddEditRecordWrapperWithHybridSupport
      mode={mode}
      id={id}
      entityId={entityId}
      layoutId={searchParams.get('layoutId') ?? undefined}
      allowNavigate={false}
      key={entityId}
      updateBreadCrumb
      shouldRedirectOnEditWhenSensitive
      showMaxRTE={
        (mode === MODE_CONSTANTS.EDIT || mode === MODE_CONSTANTS.VIEW) &&
        entityId === '18'
      }
      onSaveClick={(_e, recordId, isDraft) => {
        if (mode === 'add' && !isDraft) {
          navigate(
            {
              pathname: `/${entitiesRoute}/${entityId}/view/${recordId}`,
              search: searchParams.toString(),
            },
            {
              state: { comingFromAdd: true },
            }
          )
          return
        }
        window.history.length > 1 && !comingFromAdd
          ? navigate(`/${entitiesRoute}/${entityId}/view/${recordId}`)
          : navigate(`/${entitiesRoute}/${entityId}`)
      }}
      onCancel={() => {
        navigate(-1)
      }}
      onEditClick={() => {
        navigate(`/${entitiesRoute}/${entityId}/${editRoute}/${id}`, {
          replace: true,
        })
      }}
    />
  )
}

export const AddEditRecordWarpperCall: React.FC<{
  mode: ModeType
}> = ({ mode }) => {
  const navigate = useTenantNavigate()
  const { entityId, id } = useParams<AgentDeskParams>()
  return (
    <AddEditRecordWrapperWithHybridSupport
      mode={mode}
      id={id}
      entityId={entityId}
      allowNavigate={false}
      onSaveClick={() => {
        navigate(-1)
      }}
      onCancel={() => {
        navigate(-1)
      }}
      onEditClick={() => {
        navigate(`/${callRoute}/${entityId}/${editRoute}/${id}`)
      }}
    />
  )
}

export const AddEditRecordWarpperCallForCase: React.FC<{
  mode: ModeType
}> = ({ mode }) => {
  const navigate = useTenantNavigate()
  const { entityid, caseid } = useParams<AgentDeskForCaseParams>()
  return (
    <AddEditRecordWrapperWithHybridSupport
      mode={mode}
      id={caseid}
      entityId={entityid}
      allowNavigate={false}
      onSaveClick={() => {
        navigate('../')
      }}
      onCancel={() => {
        navigate('../')
      }}
      onEditClick={() => {
        navigate(`../edit/${caseid}`)
      }}
    />
  )
}

const AddEditRecordPage: React.FC<AddEditRecordPageProps> = ({
  mode,
  id,
  entityId,
  loaderVisible = true,
  allowNavigate = true,
  onSaveClick,
  shouldModalOpen = true,
  onCancel,
  onEditClick,
  showFooter = false,
  showButtonsInView = true,
  showButtonsInEdit = true,
  isEdit = true,
  isHideAuditButton,
  layoutId,
  isAttachCase = false,
  onAttachClick,
  showHeader = true,
  updateBreadCrumb,
  isFromIntake,
  isWorkflow = false,
  onIntakeHeaderSave,
  onIntakeHeaderCancel,
  shouldRedirectOnEditWhenSensitive,
  showMaxRTE = false,
  addAEPCDocument,
  onEditClickInViewLayout,
  hybridDetected,
}) => {
  const navigate = useTenantNavigate()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const [serviceBasedLayout, setServiceBasedLayout] = useState<{
    apiCompleted: boolean
    layoutData: EntityLayout | null
  }>({ apiCompleted: false, layoutData: null })
  const [hasViewPermission, setHasViewPermission] = useState(true)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()
  const [listingLayout, setListingLayout] = useState<EntityLayout>()
  const [dupData, setDupData] = useState<FieldValues>()
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const isLoaderVisible = useAppSelector(
    (state: RootState) => state?.loader.loading
  )
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const extraColumns: ListingTableColumn[] = [
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]
  const extraActions: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setViewDuplicateRecord(true)
        fetchViewRecord(layoutId, row?.id)
      },
    },
  ]
  const { data: allLayouts, loading } =
    useCustomFetchAgent<EntityLayoutResponse>(
      `${API_END_POINT.V3_ENTITY_MANAGER}${ENTITY_MANAGER_END_POINTS.LAYOUT}`,
      {
        params: {
          type: searchParams.get('fetchAll')
            ? undefined
            : getTypeOfLayoutByMode(mode),
          entityId: entityId,
        },
      },
      mode
    )
  const data = useMemo(() => {
    if (isAttachCase && !layoutId && !serviceBasedLayout?.apiCompleted)
      return null
    if (isAttachCase && !layoutId && serviceBasedLayout?.layoutData) {
      return [serviceBasedLayout?.layoutData]
    }
    let layouts = isArray(allLayouts) ? allLayouts : allLayouts?.content
    layouts = layouts
      ?.filter((layout) => !layout.deleted)
      .sort((a, b) => {
        return (
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        )
      })
    if (layoutId) {
      layouts = layouts?.filter(
        (layout) => layout.id.toString() === layoutId.toString()
      )
    } else {
      layouts = layouts?.filter((layout) => layout.default_value === true)
    }
    return layouts
  }, [allLayouts, layoutId, serviceBasedLayout])

  const [entityData, setEntityData] = useState()
  const isProcessing = useRef<boolean>(false)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [auditModalOpen, setAuditModalOpen] = useState<boolean>(false)
  const [enableAuditButton, setEnableAuditButton] = useState<boolean>(false)
  const [, setIsFormDirty] = useState<boolean>(false) // to do once functionality is clear
  const headerLabel = useMemo(() => {
    if (!data?.[0]?.layout_data?.header?.key) return ''
    const delimiter = data?.[0].layout_data?.header?.delimiter ?? ' '
    return data?.[0].layout_data.header.key
      .map((key) => {
        return entityData?.[key] ?? ''
      })
      .join(delimiter + ' ')
  }, [entityData, data])

  const checkCasePermission = async (caseDataResponse: {
    data?: CaseDataType
  }) => {
    try {
      if (caseDataResponse.data) {
        const permissionValue = permissionObject.Queues_And_Cases_View(
          programPermissions,
          PERMISSION_MODULES.QUEUE_AND_CASE_VISIBILITY,
          PERMISSION_ACCESSIBILITY.VIEW,
          caseDataResponse.data.programs?.id?.toString() ?? ''
        )
        setHasViewPermission(permissionValue)
      }
    } catch (err) {
      setHasViewPermission(false)
      console.error(err)
    }
  }

  // we will not be using redux because this page will be reused in 360 degree view.
  const fetchEntityData = async () => {
    if (!data || data.length === 0 || !id) {
      return
    }
    try {
      if (isSuperAdmin()) {
        setHasViewPermission(true)
      } else if (
        data[0].entity_name === 'case' ||
        data[0].entity_name === 'cases'
      ) {
        const caseDataResponse = await fetchCaseData(id ?? '', dispatch)
        if (caseDataResponse) await checkCasePermission(caseDataResponse)
      }

      const entity_data = await getEntityData(
        data?.[0].entity_name,
        data?.[0].entity_id,
        data[0].id,
        id
      )
      setEntityData(entity_data.data)
      if (data?.[0]?.entity_name?.toLowerCase() === 'patients') {
        dispatch(updatePatientData(flattenObject(entity_data.data)))
      }
    } catch (err) {
      console.error(err)
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCatch = (err?: any) => {
    if (!hasPermission(MODE_CONSTANTS.EDIT, entityId ?? '')) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.PERMISSION_DENIED,
          type: 'error',
          id: uuid(),
        })
      )
    } else {
      const responseErrorMessage = err?.response?.data?.message
      const errorMessage = responseErrorMessage.split('\n')[0]
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage ?? TOASTER_NAMESPACE.FAILED_TO_EDIT_RECORD,
          type: 'error',
        })
      )
    }
  }
  const fetchRequestorLayout = async () => {
    try {
      // let patientViewId = 0
      // let providerViewId = 0

      // entitiesList.forEach((entity: { name: string; id: number }) => {
      //   if (entity.name === ENTITY_NAME.PATIENT_VIEW_KEY) {
      //     patientViewId = entity.id ?? 0
      //   } else if (entity.name === ENTITY_NAME.PROVIDER_VIEW_KEY) {
      //     providerViewId = entity.id ?? 0
      //   }
      // })
      // let response
      // if (entityName === NAMESPACES.PATIENT_KEY) {
      //   response = await getAllLayoutApi({
      //     entityId: patientViewId?.toString() ?? '0',
      //     defaultValue: true,
      //     type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
      //   })
      //   setListingLayout(response?.data?.content?.[0])
      // } else if (entityName === NAMESPACES.PROVIDER_KEY) {
      //   response = await getAllLayoutApi({
      //     entityId: providerViewId?.toString() ?? '0',
      //     defaultValue: true,
      //     type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
      //   })
      //   setListingLayout(response?.data?.content?.[0])
      // } else {
      //   response = await getLayoutByName({
      //     entityId: element?.meta?.relationship?.parent_entity_id.toString(),
      //     layoutName: 'Requestor Search Layout',
      //   })
      //   setListingLayout(response?.data)
      // }
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: entityId ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.error(err)
    }
  }
  const fetchTableDataCallback = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    dispatch(showLoader())
    try {
      if (listingLayoutId) {
        const duplicateApiPayload = transformToDuplicateApiPayload(
          values,
          entityId ?? '',
          listingLayoutId.toString(),
          data?.[0] as LayoutResponseType
        )
        const res = await fetchDuplicateRecordsAPI(
          entityId ?? 0,
          duplicateApiPayload,
          payload?.page as number,
          payload?.size as number
        )
        setDupData(res?.data)
        if (res?.data?.content.length !== 0) {
          setIsDuplicateModalOpen(true)
        } else {
          createRecord(values)
        }
        return res?.data
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchViewRecord = async (
    layoutId: number,
    recordId?: string | number
  ) => {
    try {
      dispatch(showLoader())
      const res = await getEntityData(
        listingLayout?.entity?.entity_name ?? '',
        Number(entityId),
        Number(layoutId),
        recordId ?? ''
      )
      if (res?.data) {
        setViewRecordData(res.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: entityId ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res.data?.[0])
      }
      return res?.data?.[0]?.id
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const createRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const res = await addEntityData(
        String(listingLayout?.entity?.entity_name ?? data?.[0]?.entity_name),
        Number(listingLayout?.entity?.entity_id ?? data?.[0]?.entity_id),
        Number(data?.[0]?.id),
        (addedRecord as FieldValues) ?? (values as FieldValues)
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      allowNavigate && navigate(`/${entitiesRoute}/${entityId}`)
      onSaveClick &&
        onSaveClick(
          undefined,
          res?.data?.id,
          addedRecord?.record_status === RECORD_STATUS.DRAFT
        )
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const save = async (values: FieldValues, embedded: string[]) => {
    if (!data) {
      return
    }
    const computedFieldNames = Object.values(
      data?.[0]?.layout_data?.added_fields || {}
    )
      ?.filter((field) => field?.ui_data_type === 'computed')
      .map((field) => field?.name)

    const cleanedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key]) => !computedFieldNames.includes(key)
      )
    )

    if (mode === MODE_CONSTANTS.ADD) {
      const flagValue = validatePhoneNumberAndAddress(
        cleanedValues,
        dispatch,
        values
      )
      if (flagValue) {
        return
      }
      const entity = entitiesByName[data[0].entity_name ?? '']
      if (entity?.is_duplicate) {
        const listingLayout = await fetchRequestorLayout()
        fetchTableDataCallback(values, listingLayout?.id)
        setAddedRecord(values)
      } else {
        try {
          const res = await addEntityData(
            data[0].entity_name,
            data[0].entity_id,
            data[0].id,
            cleanedValues,
            embedded
          )
          dispatch(
            addToaster({
              message: TOASTER_NAMESPACE.ADD_SUCCESS,
              type: 'success',
              id: uuid(),
            })
          )
          allowNavigate && navigate(`/${entitiesRoute}/${entityId}`)
          onSaveClick &&
            onSaveClick(
              undefined,
              res?.data?.id,
              values.record_status === RECORD_STATUS.DRAFT
            )
        } catch (err) {
          dispatch(
            addToaster({
              message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
              type: 'error',
              id: uuid(),
            })
          )
          console.error(err)
        }
      }
    } else if (mode === MODE_CONSTANTS.EDIT) {
      if (!id) {
        console.error(NAMESPACES?.NO_ID_PROVIDED_FOR_EDITING)
        return
      }

      if (!entityData) {
        console.error(NAMESPACES?.NO_ENTITY_DATA_AVAILABLE_FOR_EDITING)
        return // this will never happen in edit mode that data is not there.
      }
      const editValues = values

      // Now is done inside formRenderer.
      // convertValuesToDiff(
      //   entityData,
      //   values,
      //   data[0].layout_data
      // )
      if (addAEPCDocument && addAEPCDocument['c_ae_pc_document.id']) {
        values.c_ae_pc_document = {
          id: addAEPCDocument['c_ae_pc_document.id'],
          document_type: values.case_document_type,
          documents: values.document_upload,
          _state: RECORD_STATE.CHANGED,
        }
      }

      try {
        const res = await editEntityData(
          data[0].entity_name,
          data[0].entity_id,
          data[0].id,
          editValues,
          id,
          embedded
        )
        dispatch(
          addToaster({
            message: TOASTER_NAMESPACE.EDIT_SUCCESS,
            type: 'success',
            id: uuid(),
          })
        )
        allowNavigate && navigate(`/${entitiesRoute}/${entityId}`)
        onSaveClick?.(undefined, res?.data?.id, undefined, editValues)
      } catch (err) {
        console.error(err)
        handleCatch(err)
      }
    }
  }

  const handleSave = async (values: FieldValues, embedded: string[]) => {
    if (isProcessing?.current) {
      return
    }

    try {
      dispatch(showLoader())
      isProcessing.current = true
      await save(values, embedded)
    } finally {
      dispatch(hideLoader())
      isProcessing.current = false
    }
    onIntakeHeaderSave?.()
  }

  const handleInvalid = (errors: FieldErrors<FieldValues>) => {
    console.error(errors)
    let requiredFilled = true

    Object.keys(errors).forEach((key) => {
      const error = errors[key]
      if (error?.type === 'required') {
        requiredFilled = false
      }
    })
    dispatch(
      addToaster({
        message: requiredFilled
          ? NAMESPACES.VALID_TOAST
          : NAMESPACES.REQUIRED_TOAST,
        type: 'error',
        id: uuid(),
      })
    )
  }

  useEffect(() => {
    if (!isSuperAdmin() && Object.keys(programPermissions).length === 0) return
    // we will not be using redux because this page will be reused in 360 degree view.
    fetchEntityData()
    if (data) {
      if (updateBreadCrumb) {
        dispatch(
          updateEntityName({
            entityName: data[0]?.entity?.singular_label ?? data[0]?.entity_name,
          })
        ) // meta data for bread crumb
      }
    }
  }, [data, id, programPermissions])

  useEffect(() => {
    const fetchEntityById = async () => {
      if (entityId) {
        const entity = await getEntityById({ entityId: parseInt(entityId) })
        setEnableAuditButton(
          isHideAuditButton ? false : entity?.data?.enable_audit ?? false
        )
      }
    }

    fetchEntityById()
  }, [entityId])

  useEffect(() => {
    if (id && isAttachCase) {
      getLayoutBasedOnServiceType(+id, isAttachCase)
        ?.then((res) => {
          const layout = res?.layoutData as unknown as LayoutResponseType
          if (CUSTOM_LAYOUTS_KEYS_LIST?.includes(layout?.type ?? '')) {
            hybridDetected?.(layout)
            return
          }
          setServiceBasedLayout(res)
        })
        ?.catch((e) => console.error(e))
    }
  }, [id, isAttachCase])

  if (
    data &&
    data.length > 0 &&
    data[0]?.type === LAYOUT_TYPE_NAMESPACE.TABS_TYPE &&
    id &&
    entityId &&
    !loading
  ) {
    return (
      <TabLayout
        layout={data[0] as LayoutResponseType}
        recordId={id}
        entityId={entityId}
        isWorkflow={isWorkflow}
      />
    )
  }

  return (
    <div className="formRendererWrapper">
      {/* <div id="addDataModalPortalDiv"></div> */}
      {isDuplicateModalOpen && (
        <Modal
          isOpen={isDuplicateModalOpen}
          closeModal={() => {
            setIsDuplicateModalOpen(false)
          }}
          showCloseButton={false}
          width="min-w-[60%] max-w-[60%]"
        >
          <div>
            <div className="flex justify-between mb-3">
              <div className="flex flex-col">
                <div className="flex">
                  <span
                    className="font-medium text-xl font-primary cursor-pointer"
                    onClick={() => {
                      setViewDuplicateRecord(false)
                    }}
                  >
                    {APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}{' '}
                  </span>
                  {viewDuplicateRecord && (
                    <span className="font-medium text-xl font-primary text-primary-450">
                      / View {viewLayout?.entity?.singular_label}
                    </span>
                  )}
                </div>
                <span className="font-light text-xs">
                  {!viewDuplicateRecord
                    ? `${dupData?.totalElements} ${
                        dupData?.totalElement > 1
                          ? `${APPLICATION_PREFERENCES_STRINGS.RECORD}s`
                          : APPLICATION_PREFERENCES_STRINGS.RECORD
                      } ${APPLICATION_PREFERENCES_STRINGS.FOUND}`
                    : `View ${viewLayout?.entity?.singular_label}`}
                </span>
              </div>
              <div className="flex gap-2">
                <CustomButton
                  onClick={() => {
                    setIsDuplicateModalOpen(false)
                    setViewDuplicateRecord(false)
                  }}
                >
                  {APPLICATION_PREFERENCES_STRINGS?.CANCEL}
                </CustomButton>
                <CustomButton
                  isFilled
                  onClick={() => {
                    createRecord()
                    setIsDuplicateModalOpen(false)
                    setViewDuplicateRecord(false)
                  }}
                >
                  {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
                </CustomButton>
              </div>
            </div>
            {!viewDuplicateRecord ? (
              <ListingTable
                entityId={Number(entityId)}
                entityName={String(listingLayout?.entity?.entity_name)}
                extraActions={extraActions}
                layout={listingLayout as LayoutResponseType}
                dataFetchCallback={(payload) =>
                  fetchTableDataCallback(
                    addedRecord ?? {},
                    listingLayout?.id ?? 0,
                    payload
                  )
                }
                extraColumns={extraColumns}
                hideFilters={true}
                openInNewTab={true}
              />
            ) : (
              <FormRenderer
                heading={null}
                layout={viewLayout?.layout_data as LayoutData}
                mode={MODE_CONSTANTS.VIEW}
                handleFormSubmit={noop}
                fullLayout={viewLayout as EntityLayout}
                data={viewRecordData}
              />
            )}
          </div>
        </Modal>
      )}
      {loading && (
        <div>
          <Loader
            isGlobal={loaderVisible}
            loaderHeight={!loaderVisible ? '40' : '126'}
            loaderWidth={!loaderVisible ? '40' : '126'}
          />
        </div>
      )}
      {!hasViewPermission && !isLoaderVisible ? (
        <Modal
          isOpen={true}
          closeModal={noop}
          showCloseButton={false}
          width="min-w-[40rem] max-w-[98%]"
          cssClassName="backdrop-blur-sm"
        >
          <div className="flex justify-center items-center p-5">
            {PERMISSION_ASSIGNMENT.NO_ACCESS_FOR_CASE}
          </div>
        </Modal>
      ) : null}
      {data && data.length > 0 ? (
        <FormRenderer
          showPatentInformation={
            data?.[0]?.entity_name?.toLowerCase() === 'patient_insurances'
          }
          mode={mode}
          heading={
            showHeader && (
              <FormHeader
                mode={mode}
                data={data}
                headerLabel={headerLabel}
                shouldModalOpen={shouldModalOpen}
                enableAuditButton={enableAuditButton}
                allowNavigate={allowNavigate}
                entityId={entityId}
                isAttachCase={isAttachCase}
                id={id}
                isFormDirty={true} // || isFormDirty
                showButtonsInView={showButtonsInView}
                showButtonsInEdit={
                  showButtonsInEdit &&
                  (!entityData?.['is_client_controlled'] ||
                    hasSensitiveDataPermission())
                }
                showFooter={showFooter}
                showDraftInEdit={
                  entityData?.['record_status'] === RECORD_STATUS.DRAFT
                }
                showDraftInAdd={true}
                showEditInView={
                  isEdit &&
                  entityData?.['record_status'] !== RECORD_STATUS.INACTIVE &&
                  (!entityData?.['is_client_controlled'] ||
                    hasSensitiveDataPermission())
                }
                setModalOpen={setModalOpen}
                onCancel={onCancel}
                setAuditModalOpen={setAuditModalOpen}
                onAttachClick={onAttachClick}
                onEditClick={onEditClick}
                onSaveButtonClick={onIntakeHeaderSave}
                onCancelButtonClick={onIntakeHeaderCancel}
                shouldRedirectOnEditWhenSensitive={
                  shouldRedirectOnEditWhenSensitive
                }
                showCheckEligibiltiy={isEntityEditRoute(pathname)}
                onEditClickInViewLayout={onEditClickInViewLayout}
              />
            )
          }
          layout={data[0].layout_data}
          fullLayout={data[0]}
          handleFormSubmit={(values: FieldValues, embedded: string[]) => {
            handleSave({ ...values }, embedded)
            if (isAttachCase) {
              removeCheckAttachKeyFromSession()
            }
          }}
          handleFormDraftSubmit={(values: FieldValues, embedded: string[]) => {
            handleSave(
              { ...values, record_status: RECORD_STATUS.DRAFT },
              embedded
            )
          }}
          data={entityData}
          handleFormInvalid={handleInvalid}
          setIsFormDirty={setIsFormDirty}
          footer={
            showFooter && (
              <DefaultFormFooter
                mode={mode}
                isFormDirty={true} // || isFormDirty
                shouldModalOpen={shouldModalOpen}
                data={data}
                headerLabel={headerLabel}
                enableAuditButton={enableAuditButton}
                allowNavigate={allowNavigate}
                entityId={entityId}
                isEdit={isEdit}
                id={id}
                setModalOpen={setModalOpen}
                setAuditModalOpen={setAuditModalOpen}
                onCancel={onCancel}
                onEditClick={onEditClick}
                tabIndex={TAB_INDEX_DEFAULT}
              />
            )
          }
          isFromIntake={isFromIntake}
          showMaxRTE={showMaxRTE}
        />
      ) : (
        !loading && (
          <div className="flex relative justify-center items-center h-full m-auto font-primary text-center  min-h-20">
            <div
              className="absolute top-0 right-0 cursor-pointer"
              onClick={(e) => onCancel && onCancel(e, MODE_CONSTANTS.VIEW)}
              tabIndex={TAB_INDEX_DEFAULT}
              onKeyDown={(e) => {
                if (
                  e?.key === ShortcutKeys.Enter ||
                  e?.key === ShortcutKeys.Space
                ) {
                  onCancel && onCancel(e, MODE_CONSTANTS.VIEW)
                }
              }}
            >
              <SvgCross />
            </div>
            <div className="font-semibold">{NAMESPACES.NO_LAYOUT}</div>
          </div>
        )
      )}
      <ConfirmDialog
        open={modalOpen}
        message={NAMESPACES.CONFIRM_CANCEL}
        onCancel={() => setModalOpen(false)}
        onConfirm={() => {
          if (onCancel) {
            onCancel()
          } else if (allowNavigate) {
            navigate(-1)
          }
          setModalOpen(false)
          if (isAttachCase) {
            removeCheckAttachKeyFromSession()
          }
        }}
      />
      {auditModalOpen && (
        <Modal
          isOpen={auditModalOpen}
          closeModal={() => setAuditModalOpen(false)}
        >
          <div className=" flex items-center justify-center">
            <div className="">
              <div className="text-sm font-primary font-medium">
                {STRINGS.AUDIT_HISTORY}
              </div>

              <div className="flex gap-1">
                <div className="text-xs font-primary mt-1">
                  {capitalizeEntitySingularLabel(
                    data?.[0]?.entity?.singular_label ??
                      data?.[0]?.entity_name ??
                      ''
                  )}
                  :
                </div>
                <div className="text-xs font-primary mt-1 text-accent-500">
                  {headerLabel}
                </div>
              </div>

              <div className="flex flex-col items-center justify-center my-3 h-[21.25rem] w-[66.25rem] border rounded">
                <SvgEntity height="4.8rem" width="5.25rem" />
                <div className="mt-10 font-primary text-center">
                  {STRINGS.AUDIT_NOT_AVAILABLE_MESSAGE}
                </div>
              </div>

              <div className="flex justify-end">
                <CustomButton
                  isFilled={true}
                  onClick={() => setAuditModalOpen(false)}
                >
                  {STRINGS.CLOSE}
                </CustomButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default AddEditRecordPage

export const DefaultFormFooter: React.FC<{
  mode: ModeType
  isFormDirty: boolean
  shouldModalOpen: boolean
  data: EntityLayout[]
  headerLabel: string
  enableAuditButton: boolean
  allowNavigate: boolean
  entityId: string | undefined
  isEdit: boolean
  id: string | undefined
  setModalOpen?: (e: boolean) => void
  setAuditModalOpen?: (e: boolean) => void
  onCancel:
    | ((
        e?:
          | React.MouseEvent<HTMLButtonElement, MouseEvent>
          | React.KeyboardEvent<HTMLDivElement>
          | React.MouseEvent<HTMLDivElement, MouseEvent>,
        view?: string
      ) => void)
    | undefined
  onEditClick: (() => void) | undefined
  tabIndex?: number
}> = ({
  mode,
  isFormDirty,
  shouldModalOpen,
  data,
  headerLabel,
  enableAuditButton,
  allowNavigate,
  entityId,
  isEdit,
  id,
  setModalOpen,
  setAuditModalOpen,
  onCancel,
  onEditClick,
  tabIndex,
}) => {
  const navigate = useTenantNavigate()
  switch (mode) {
    case MODE_CONSTANTS.ADD:
      return (
        <div className="flex justify-between items-center">
          <div className="flex gap-2 align-middle">
            <CustomButton
              onClick={() => setModalOpen?.(true)}
              color="primary"
              tabIndex={tabIndex}
            >
              {NAMESPACES.CANCEL_BUTTON}
            </CustomButton>
            <CustomButton
              isFilled
              color="primary"
              type="submit"
              tabIndex={tabIndex}
            >
              {NAMESPACES.SAVE_BUTTON}
            </CustomButton>
          </div>
        </div>
      )
    case MODE_CONSTANTS.EDIT:
      return (
        <div className="flex justify-end items-center mt-4">
          <div className="flex gap-2">
            <CustomButton
              onClick={() =>
                shouldModalOpen ? setModalOpen?.(true) : onCancel && onCancel()
              }
              color="primary"
              tabIndex={tabIndex}
            >
              {NAMESPACES.CANCEL_BUTTON}
            </CustomButton>
            <CustomButton
              isFilled
              color="primary"
              type="submit"
              disabled={!isFormDirty}
              tabIndex={tabIndex}
            >
              {NAMESPACES.SAVE_BUTTON}
            </CustomButton>
          </div>
        </div>
      )
    case MODE_CONSTANTS.VIEW:
      return (
        <div className="flex justify-between items-center">
          <div className="font-primary">
            <div className="text-base font-medium">
              {renderValuesWithDelimiter([
                capitalizeEntitySingularLabel(
                  data?.[0]?.entity?.singular_label ??
                    data?.[0]?.entity_name ??
                    ''
                ),
                headerLabel,
              ])}
            </div>
            <div className="text-xs font-light">{NAMESPACES.OVERVIEW}</div>
          </div>
          <div className="flex gap-2">
            {enableAuditButton ? (
              <>
                <Tooltip content={STRINGS.AUDIT_HISTORY} position="bottom">
                  <CustomButton
                    onClick={() => setAuditModalOpen?.(true)}
                    color="others"
                    tabIndex={tabIndex}
                  >
                    <div className="flex items-center justify-center gap-1">
                      <SvgAudit width={'1.25rem'} height={'1.25rem'} />
                    </div>
                  </CustomButton>
                </Tooltip>
                <div className="flex flex-col items-center justify-center">
                  <SvgVerticalSplitter />
                </div>
              </>
            ) : null}
            <CustomButton
              onClick={(e) => {
                allowNavigate && navigate(-1)
                onCancel && onCancel(e, MODE_CONSTANTS.VIEW)
              }}
              color="primary"
              tabIndex={tabIndex}
            >
              {NAMESPACES.BACK_BUTTON}
            </CustomButton>
            {isEdit && (
              <CustomButton
                type="button"
                onClick={() => {
                  if (onEditClick) {
                    onEditClick()
                  } else if (allowNavigate) {
                    navigate(`/${entitiesRoute}/${entityId}/${editRoute}/${id}`)
                  }
                }}
                color="others"
                className="border flex items-center justify-center"
                tabIndex={tabIndex}
              >
                <div className="flex items-center justify-center gap-1">
                  <SvgEditBlue width={'0.75rem'} height={'0.75rem'} />
                  <span className="text-accent-900 text-xs">
                    {NAMESPACES.EDIT_BUTTON}
                  </span>
                </div>
              </CustomButton>
            )}
          </div>
        </div>
      )
  }
}

export const FormHeader: React.FC<{
  mode: ModeType
  data: EntityLayout[]
  headerLabel?: string
  shouldModalOpen: boolean
  enableAuditButton?: boolean
  allowNavigate: boolean
  entityId: string | undefined
  isAttachCase: boolean
  id: string | undefined
  isFormDirty: boolean
  showFooter: boolean
  showDraftInEdit?: boolean
  showDraftInAdd: boolean
  showEditInView?: boolean
  showButtonsInView?: boolean
  showButtonsInEdit?: boolean
  shouldRedirectOnEditWhenSensitive?: boolean
  setModalOpen?: React.Dispatch<React.SetStateAction<boolean>>
  onCancel:
    | ((
        e?:
          | React.MouseEvent<HTMLButtonElement, MouseEvent>
          | React.KeyboardEvent<HTMLDivElement>
          | React.MouseEvent<HTMLDivElement, MouseEvent>,
        view?: string
      ) => void)
    | undefined
  setAuditModalOpen?: React.Dispatch<React.SetStateAction<boolean>>
  onAttachClick: (() => void) | undefined
  onEditClick: (() => void) | undefined
  onSaveButtonClick?: () => void
  onCancelButtonClick?: () => void
  showCheckEligibiltiy?: boolean
  isBorderBottom?: boolean
  onEditClickInViewLayout?: () => void
}> = ({
  mode,
  data,
  headerLabel,
  shouldModalOpen,
  enableAuditButton,
  allowNavigate,
  entityId,
  isAttachCase,
  id,
  isFormDirty,
  showFooter,
  showDraftInEdit,
  showDraftInAdd,
  showEditInView,
  showButtonsInView = true,
  showButtonsInEdit = true,
  setModalOpen,
  onCancel,
  setAuditModalOpen,
  onAttachClick,
  onEditClick,
  onCancelButtonClick,
  shouldRedirectOnEditWhenSensitive = false,
  showCheckEligibiltiy = false,
  isBorderBottom = true,
  onEditClickInViewLayout,
}) => {
  const selectedClientTenant = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant
  )
  const { getValues } = useFormContext()
  const MEC_PORTAL_BTN = true
  const navigate = useTenantNavigate()
  useEffect(() => {
    if (
      shouldRedirectOnEditWhenSensitive &&
      mode === MODE_CONSTANTS.EDIT &&
      !showButtonsInEdit
    ) {
      navigate(-1)
    }
  }, [showButtonsInEdit])
  switch (mode) {
    case MODE_CONSTANTS.ADD:
      return (
        <div
          className={`flex justify-between items-center px-3 py-2 ${
            isBorderBottom ? 'border-b-2' : ''
          }`}
        >
          <div className="font-primary">
            <div className="text-base font-medium">
              {renderValuesWithDelimiter([
                selectedClientTenant?.name_of_organization,
                capitalizeEntitySingularLabel(
                  data?.[0]?.entity?.singular_label ??
                    data?.[0]?.entity_name ??
                    ''
                ),
              ])}
            </div>
            <div className="text-xs font-light">
              Add{' '}
              {capitalizeEntitySingularLabel(
                data?.[0]?.entity?.singular_label ??
                  data?.[0]?.entity_name ??
                  ''
              )}{' '}
            </div>
          </div>
          {!showFooter && (
            <div className="flex gap-2 align-middle">
              <CustomButton
                onClick={() => {
                  onCancelButtonClick?.()
                  setModalOpen?.(true)
                }}
                color="primary"
                dataQaId="cancel"
                tabIndex={TAB_INDEX_DEFAULT}
              >
                {NAMESPACES.CANCEL_BUTTON}
              </CustomButton>
              {showDraftInAdd && (
                <CustomButton
                  isFilled
                  color="primary"
                  type="submit"
                  dataQaId="save-as-draft"
                  id={FORM_CONSTANTS.SAVE_AS_DRAFT}
                  widthClass="w-[6.9rem]"
                  tabIndex={TAB_INDEX_DEFAULT}
                  disabled={isReadOnlyUser()}
                >
                  {NAMESPACES.SAVE_AS_DRAFT}
                </CustomButton>
              )}
              <CustomButton
                isFilled
                color="primary"
                type="submit"
                dataQaId="save"
                tabIndex={TAB_INDEX_DEFAULT}
                disabled={isReadOnlyUser()}
              >
                {NAMESPACES.SAVE_BUTTON}
              </CustomButton>
            </div>
          )}
        </div>
      )
    case MODE_CONSTANTS.EDIT:
      return (
        <div
          className={`flex justify-between items-center px-3 py-2 ${
            isBorderBottom ? 'border-b-2' : ''
          } mb-1`}
        >
          <div className="font-primary">
            <div className="text-base font-medium">
              {renderValuesWithDelimiter([
                capitalizeEntitySingularLabel(
                  toSpacesCase(
                    data?.[0]?.entity?.singular_label ??
                      data?.[0]?.entity_name ??
                      ''
                  )
                ),
                headerLabel,
              ])}
            </div>
            <div>
              <span className="text-xs font-light">
                {headerLabel
                  ? `Edit ${headerLabel}'s details`
                  : `${NAMESPACES.EDIT_BUTTON}`}
              </span>
            </div>
          </div>
          {
            <div className="flex gap-2 items-center justify-center">
              {data?.[0]?.layout_data?.meta?.is_mec_consent &&
                MEC_PORTAL_BTN && (
                  <PatientEConsent
                    patId={id ?? ''}
                    from={CHECK_ELIGIBILITY_LOCATION.ENTITIES}
                  />
                )}
              {data?.[0]?.layout_data?.meta?.eligibility_check &&
                showCheckEligibiltiy && (
                  <CheckEligibilityMaxRTE
                    patientId={id ?? ''}
                    showDivider={!showFooter}
                    from={CHECK_ELIGIBILITY_LOCATION.ENTITIES}
                    getValues={getValues}
                  />
                )}
              {!showFooter && (
                <>
                  <CustomButton
                    onClick={() => {
                      onCancelButtonClick?.()
                      shouldModalOpen
                        ? setModalOpen?.(true)
                        : onCancel && onCancel()
                    }}
                    dataQaId="cancel"
                    color="primary"
                    tabIndex={TAB_INDEX_DEFAULT}
                  >
                    {NAMESPACES.CANCEL_BUTTON}
                  </CustomButton>
                  {showDraftInEdit && showButtonsInEdit && (
                    <CustomButton
                      isFilled
                      color="primary"
                      type="submit"
                      dataQaId="save-as-draft"
                      id={FORM_CONSTANTS.SAVE_AS_DRAFT}
                      widthClass="w-[6.9rem]"
                      tabIndex={TAB_INDEX_DEFAULT}
                    >
                      {NAMESPACES.SAVE_AS_DRAFT}
                    </CustomButton>
                  )}
                  {showButtonsInEdit && (
                    <CustomButton
                      isFilled
                      color="primary"
                      type="submit"
                      dataQaId="save"
                      tabIndex={TAB_INDEX_DEFAULT}
                      disabled={isReadOnlyUser() || !isFormDirty}
                    >
                      {showDraftInEdit
                        ? NAMESPACES.SAVE_BUTTON
                        : NAMESPACES.UPDATE_BUTTON}
                    </CustomButton>
                  )}
                </>
              )}
            </div>
          }
        </div>
      )
    case MODE_CONSTANTS.VIEW:
      return (
        <div
          className={`flex justify-between items-center px-3 py-2 ${
            isBorderBottom ? 'border-b-2' : ''
          }`}
        >
          <div className="font-primary">
            <div className="text-base font-medium">
              {renderValuesWithDelimiter([
                capitalizeEntitySingularLabel(
                  data?.[0]?.entity?.singular_label ?? data?.[0]?.entity_name
                ),
                headerLabel,
              ])}
            </div>
          </div>
          {showButtonsInView && (
            <div
              className={`flex gap-2 ${
                onEditClickInViewLayout ? 'flex-row-reverse' : ''
              }`}
            >
              {enableAuditButton ? (
                <>
                  <Tooltip content={STRINGS.AUDIT_HISTORY} position="bottom">
                    <CustomButton
                      onClick={() => setAuditModalOpen?.(true)}
                      color="others"
                      verticalPaddingClasses="py-[0.37rem]"
                      widthClass=""
                      tabIndex={TAB_INDEX_DEFAULT}
                    >
                      <div className="flex items-center justify-center gap-1">
                        <SvgAudit width={'1.25rem'} height={'1.25rem'} />
                      </div>
                    </CustomButton>
                  </Tooltip>
                  <div className="flex flex-col items-center justify-center">
                    <SvgVerticalSplitter />
                  </div>
                </>
              ) : null}
              {(window?.history?.length > 2 || onEditClickInViewLayout) && (
                <CustomButton
                  onClick={(e) => {
                    allowNavigate && navigate(-1)
                    onCancel && onCancel(e, MODE_CONSTANTS.VIEW)
                  }}
                  tabIndex={TAB_INDEX_DEFAULT}
                  color="primary"
                  isFilled={!!onEditClickInViewLayout}
                >
                  {onEditClickInViewLayout
                    ? NAMESPACES.CLOSE
                    : NAMESPACES.BACK_BUTTON}
                </CustomButton>
              )}
              {isAttachCase && (
                <CustomButton
                  isFilled={true}
                  onClick={() => {
                    allowNavigate && navigate(`/${entitiesRoute}/${entityId}`)
                    onAttachClick && onAttachClick()
                  }}
                  tabIndex={TAB_INDEX_DEFAULT}
                  color="primary"
                >
                  {NAMESPACES.ATTACH}
                </CustomButton>
              )}
              {!isReadOnlyUser()
                ? showEditInView &&
                  hasPermission(MODE_CONSTANTS.EDIT, entityId ?? '') && (
                    <CustomButton
                      type="button"
                      onClick={() => {
                        if (onEditClick) {
                          onEditClick()
                        } else if (allowNavigate) {
                          navigate(
                            `/${entitiesRoute}/${entityId}/${editRoute}/${id}`,
                            { replace: true }
                          )
                        }
                      }}
                      color="primary"
                      tabIndex={TAB_INDEX_DEFAULT}
                      isFilled
                      className="border flex items-center justify-center"
                    >
                      <div className="flex items-center justify-center gap-1">
                        <SvgEditBlue
                          width={'0.75rem'}
                          height={'0.75rem'}
                          className="svg-path-stroke-accent-0"
                        />
                        <span className="text-accent-0 text-xs">
                          {NAMESPACES.EDIT}
                        </span>
                      </div>
                    </CustomButton>
                  )
                : null}
              {onEditClickInViewLayout && (
                <CustomButton
                  onClick={onEditClickInViewLayout}
                  tabIndex={TAB_INDEX_DEFAULT}
                  color="primary"
                >
                  {NAMESPACES.EDIT_BUTTON}
                </CustomButton>
              )}
            </div>
          )}
        </div>
      )
  }
}
